import { AttributionPayload } from './types';

const FIRST_TOUCH_ATTRIBUTION_KEY = 'wizium_first_touch_attribution';

const ATTRIBUTION_PARAMS = [
    'utm_id',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gclid',
    'fbclid',
    'yclid',
    'msclkid',
    'ttclid',
    'twclid',
    'wiz_cid',
] as const;

function sanitizeValue(value: string | null, maxLength = 255): string | undefined {
  if (!value) return undefined;
  const trimmed = value.trim();
  if (!trimmed) return undefined;
  return trimmed.slice(0, maxLength);
}

function getAttributionFromUrl(): AttributionPayload {
  if (typeof window === 'undefined') {
    return {};
  }

  const params = new URLSearchParams(window.location.search);
  const result: AttributionPayload = {};

  for (const key of ATTRIBUTION_PARAMS) {
    const value = sanitizeValue(params.get(key));
    if (value) {
      result[key] = value;
    }
  }

  return result;
}

function hasAttribution(payload: AttributionPayload): boolean {
  return ATTRIBUTION_PARAMS.some(key => Boolean(payload[key]));
}

export function captureFirstTouchAttribution(): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    const existing = window.localStorage.getItem(FIRST_TOUCH_ATTRIBUTION_KEY);
    if (existing) {
      return;
    }

    const urlAttribution = getAttributionFromUrl();
    if (!hasAttribution(urlAttribution)) {
      return;
    }

    const payload: AttributionPayload = {
      ...urlAttribution,
      referrer: sanitizeValue(document.referrer || null),
      landing_page: sanitizeValue(window.location.href, 2048),
    };

    window.localStorage.setItem(FIRST_TOUCH_ATTRIBUTION_KEY, JSON.stringify(payload));
  } catch {
    // Safari private mode or storage quota exceeded
  }
}

export function getFirstTouchAttribution(): AttributionPayload | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  try {
    const raw = window.localStorage.getItem(FIRST_TOUCH_ATTRIBUTION_KEY);
    if (!raw) {
      return undefined;
    }
    const parsed = JSON.parse(raw) as AttributionPayload;
    return hasAttribution(parsed) ? parsed : undefined;
  } catch {
    return undefined;
  }
}
